import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

export type StaffPoolEntry = {
  userId: string;
  email: string;
  name?: string;
  lastInvitedAt?: string;
  lastEventTitle?: string;
  totalEventsInvitedTo: number;
};

export function useStaffPool(sellerId: string, excludePageId?: string) {
  const { token } = useAuth();

  const q = useQuery<StaffPoolEntry[]>({
    queryKey: ['staff-pool', sellerId, excludePageId ?? null],
    queryFn: () => {
      const qs = new URLSearchParams({ sellerId });
      if (excludePageId) qs.set('excludePageId', excludePageId);
      return fetcher(`/scanner/staff-pool/list?${qs.toString()}`, token).then(
        (data: StaffPoolEntry[] | undefined) => data ?? [],
      );
    },
    enabled: !!sellerId && !!token,
  });

  return { pool: q.data ?? [], isLoading: q.isLoading };
}
